module.exports = __webpack_public_path__ + "img/Think-Air-2021-Purple-PNG.5466f2ad.png";